import { ref, set } from "firebase/database";
import { db } from '../Firebase.config'

export default async function addBlogUs(data){
    set(ref(db, 'blogs/us/' + data.id), {
        id: data.id,
        image: data.image,
        title: data.title,
        description: data.description,
        date: data.date,
        author: data.author
    });
}